import { Component, Input } from '@angular/core';
import { DashboardResponse } from '../../../api/models/dashboardResponse';

@Component({
    selector: 'dispatched',
    template: require('./dashboardDispatched.component.html')
})

export class DispatchedComponent {

    public ham: boolean = false;

    @Input() dataSearch: DashboardResponse;
    @Input() status: any;
    
    constructor() {
        /* empty */
    }

    showHam() {
        this.ham = (this.ham) ? false : true;
    }    
}